
/**
 *  If form is served as an iFrame, the conversion page comes from document.referer;
 *  otherwise, the current url where the form was submitted
 */
export default function isIframeForm(form) {
  return !!form.closest('.vt-leadform--iframe');
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/is_iframe_form.js